<template>
    <div class="card">
        <div class="card-header bg-white" v-if="title">
            <h3 class="card-title">{{$t('components.stocklist.offers.title')}}</h3>
        </div>
        <div class="card-body">
            <router-link :to="resolveRoute('app.stocklist')" class="text-wellis-gold">
                {{$t('components.shopord.showAllSpas')}}
            </router-link>
            <div class="row" v-if="offers.length > 0">
                <div :class="['col-sm-12 p-0 d-flex', resolveSize]" v-for="item in offers" :key="item.name+'_'+Object.values(item.configs).length">
                    <StockFifoProductCard :stock-item="item" :btn-configurator="btnConfigurator" :btn-add-cart="btnAddCart"/>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-sm-12">
                    <p>{{$t('components.products.offers.notfound')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StockFifoProductCard from "./StockFifoProductCard";

    export default {
        name: "StockFifoOffers",
        components: {StockFifoProductCard},
        props: {
            offers: Array,
            hasPrice: Boolean,
            catalogNo: String,
            acrylicColor: String,
            btnConfigurator: Boolean,
            btnAddCart: Boolean,
            small: Boolean,
            title: Boolean
        },

        computed: {
            resolveRoute() {
                return routeName => {
                    if(!this.$store.getters['configStore/getStocklistModuleStatus']) {
                        routeName = 'app.stock-mixed';
                    }

                    let route = {
                        name: routeName,
                        query: {

                        }
                    };

                    if(this.catalogNo) {
                        route.query.product = JSON.stringify([this.catalogNo]);
                    }

                    if (this.acrylicColor) {
                        route.query.characteristics = JSON.stringify({
                            "SZÍNVÁLASZTÉK": [this.acrylicColor]
                        });
                    }

                    return route;
                }
            },

            resolveSize() {
                return this.small ? 'col-md-3' : '';
            }
        }
    }
</script>

<style scoped>

</style>
